export default __webpack_public_path__ + "static/media/182.a2f96be6.jpg";